<template>
	<button
		type="button"
		@click="$emit('selectRate', selectFrom, selectTo)"
		class="btn btn-rate btn-block btn-white px-1"
		:class="{
			active: rateFrom == selectFrom && rateTo == selectTo,
		}"
	>
		{{ selectFrom }} - {{ selectTo }} €
	</button>
</template>

<script>
export default {
	name: 'BtnRateSelect',
	props: {
		rateFrom: Number,
		rateTo: Number,
		selectFrom: Number,
		selectTo: Number,
	},
}
</script>

<style lang="scss" scoped>
.btn {
	&:focus {
		//border: none transparent !important;
		outline: transparent !important;
		box-shadow: none;
	}

	&.btn-rate {
		color: $gray-600;
		font-size: $px13;
		font-weight: 600;

		&.active {
			color: $primary;
			border-color: $primary !important;
		}
	}
}
</style>
